/* Offer countdown bar: counts down to the end time printed on [data-ftoc-end] (epoch seconds,
 * set from the section's Brisbane end date). Same instant for every visitor; a refresh never
 * restarts it. At zero it hides the bar or drops the clock, as the section says. */
(function () {
  'use strict';
  if (window.__ftocClock) return;
  window.__ftocClock = true;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function set(bar, k, v) { var el = bar.querySelector('[data-ftoc="' + k + '"]'); if (el && el.textContent !== v) el.textContent = v; }

  function tick() {
    var bars = document.querySelectorAll('[data-ftoc-end]');
    var now = Date.now();
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      var left = Math.floor((parseInt(bar.getAttribute('data-ftoc-end'), 10) * 1000 - now) / 1000);
      if (left <= 0) {
        if (bar.getAttribute('data-ftoc-ended') === 'hide') bar.style.display = 'none';
        var c = bar.querySelector('.ftoc__clock');
        if (c) c.parentNode.removeChild(c);
        continue;
      }
      var d = Math.floor(left / 86400);
      var du = bar.querySelector('[data-ftoc-unit="d"]');
      if (du) du.hidden = d === 0;
      set(bar, 'd', '' + d);
      set(bar, 'h', pad(Math.floor((left % 86400) / 3600)));
      set(bar, 'm', pad(Math.floor((left % 3600) / 60)));
      set(bar, 's', pad(left % 60));
    }
  }

  function start() {
    tick();
    setInterval(function () { if (!document.hidden) tick(); }, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
